module.exports = __webpack_public_path__ + "img/explain-info.fdf98a65.jpg";